var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CpButton',{staticClass:"remove-element-button",attrs:{"color":"dark","size":_vm.size,"callback":_vm.onClick}},[_c('span',{staticClass:"circle"},[_vm._v("—")]),(_vm.size != 'small')?[_vm._v("Entfernen")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }